<template>
	<div class="pt-2">
		<CommonFlame :title="title">
			<template v-slot:app-bar-btn>
				<v-btn color="white" text @click="setCost()">
					<v-icon class="mr-1">mdi-plus</v-icon>
					工数を登録する
				</v-btn>
			</template>
			<div class="table-container mt-4">
				<v-data-table
					locale="ja-JP"
					:items="ordered_products"
					:headers="headers"
					:mobile-breakpoint="240"
					hide-default-footer
					disable-filtering
					disable-pagination
					disable-sort
					no-data-text="データがありません。"
				>
					<template v-slot:item="{ item }">
						<tr @click="openShowDialog(item.id)">
							<td>{{ item.product_number }}</td>
							<td>{{ item.product.name }}</td>
							<td>{{ item.man_hour.planned_used_hours }}</td>
							<td>{{ item.man_hour.used_hours }}</td>
						</tr>
					</template>
				</v-data-table>
			</div>
			<PaginationModule :pagination="pagination" @get-page="getPage($event)"></PaginationModule>
		</CommonFlame>
		<DesignCostNewDialog
			:dialog.sync="newDialog"
			:costCategory="cost_category"
			@saveDesignCost="saveDesignCost"
			@savePlannedDesignCost="savePlannedDesignCost"
		/>
		<DesignCostShowDialog
			:dialog.sync="showDialog"
			:orderedProductId="ordered_product_id"
			@updateDesignCost="reload"
		/>
	</div>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import CommonFlame from "../shared/CommonFlame.vue"
import FunctionTitle from "../shared/FunctionTitle.vue"
import PaginationModule from "../../modules/PaginationModule.vue"
import DesignCostNewDialog from "./components/DesignCostNewDialog.vue"
import DesignCostShowDialog from "./components/DesignCostShowDialog.vue"

export default {
	components: {
		CommonFlame,
		FunctionTitle,
		PaginationModule,
		DesignCostNewDialog,
		DesignCostShowDialog,
	},
	data() {
		return {
			title: "設計工数一覧",
			authority_flag: false,
			headers: headers(),
			pagination: {
				count: null,
				current: 1,
				limit_value: null,
				next: null,
				pages: null,
				previous: null,
			},
			q: {},
			selectedProduct: null,
			newDialog: false,
			showDialog: false,
			ordered_products: [],
			ordered_product_id: null,
			cost_category: {},
		}
	},

	mounted() {
		const page = this.$route.query.page ? this.$route.query.page : 1
		this.setQuery()
		this.fetchDesignCosts(this.q, page)
	},
	methods: {
		fetchDesignCosts(q, page) {
			const headers = authenticate.setHeader()
			const params = { page, q }
			axios
				.get("/erp/v1/design_costs/design_costs", {
					params,
					headers,
				})
				.then((response) => {
					this.ordered_products = response.data.ordered_products
					this.cost_category = response.data.cost_category
					this.pagination = response.data.pagination
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},

		getPage(page) {
			this.fetchProducts(this.q, page)
			this.$router.push({
				name: this.$route.name,
				query: { page: page, ...this.q },
			})
			window.scrollTo({
				top: 0,
				behavior: "smooth",
			})
		},
		//
		setQuery() {
			const query = this.$route.query
			let q = this.q
			Object.keys(this.$route.query).forEach((query_key) => {
				if (query[query_key] && query_key != "page") {
					q[query_key] = this.formatQuery(query[query_key])
				}
			})
			this.q = q
		},
		formatQuery(query) {
			if (query instanceof Array) {
				return query.map((v) => (isFinite(v) ? Number(v) : v))
			} else if (isFinite(query)) {
				return Number(query)
			} else {
				return query
			}
		},
		setCost() {
			this.newDialog = true
		},
		openShowDialog(ordered_product_id) {
			this.showDialog = true
			this.ordered_product_id = ordered_product_id
		},
		saveDesignCost(orderedProduct, usedHours, wage) {
			const headers = authenticate.setHeader()
			const params = { ordered_product_id: orderedProduct.id, used_hours: usedHours, wage: wage }
			axios
				.post("/erp/v1/design_costs/design_costs", params, { headers })
				.then((response) => {
					this.newDialog = false
					this.fetchDesignCosts(this.q, this.pagination.current)
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		savePlannedDesignCost(orderedProduct, plannedUsedHours, wage) {
			const headers = authenticate.setHeader()
			const params = {
				ordered_product_id: orderedProduct.id,
				planned_used_hours: plannedUsedHours,
				wage: wage,
			}
			axios
				.post("/erp/v1/design_costs/design_costs", params, { headers })
				.then((response) => {
					this.newDialog = false
					this.fetchDesignCosts(this.q, this.pagination.current)
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		reload() {
			this.fetchDesignCosts(this.q, this.pagination.current)
		},
	},
}

function headers() {
	return [
		{
			text: "製造番号 ",
			value: "product_number",
			width: "200px",
		},
		{
			text: "製品名",
			value: "name",
			width: "200px",
		},
		{
			text: "予定設計工数(単位:時間)",
			value: "planned_used_hours",
			width: "150px",
		},
		{
			text: "設計工数(単位:時間)",
			value: "used_hours",
			width: "150px",
		},
	]
}
</script>
